import { Component } from '@angular/core';

import { FileTypeBadgeComponent } from '@camelot/files-basic';
import { FileType } from '@camelot/services';

import { AbstractCellComponent } from '../../abstract';

@Component({
  host: { 'data-cid': 'file-type-cell' },
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '',
  imports: [FileTypeBadgeComponent],
  template: `<div class="align-center" style="height: 100%">
    <cam-file-type-badge [fileType]="this.type"></cam-file-type-badge>
  </div>`,
})
export class FileTypeCellComponent extends AbstractCellComponent<any, FileType> {
  get type() {
    return this.value ?? FileType.Unknown;
  }
}
